module.exports = __webpack_public_path__ + "img/snapchat.e7330ae7.svg";